import { IconX } from "@tabler/icons-react";
import clsx from "clsx";
import React from "react";

const SelectedItem = ({
  rec,
  removeItem,
}: {
  rec: string;
  removeItem?: (tag: string) => void;
}) => {
  return (
    <div
      className={clsx(
        "text-xs py-0.5 pl-2 pr-1.5 items-center rounded-full whitespace-nowrap",
        "bg-indigo-50 text-indigo-700 flex h-[23px]",
        { "pr-2": !removeItem }
      )}
    >
      {rec}
      {removeItem && (
        <IconX
          width={14}
          className="ml-1 text-indigo-400 cursor-pointer"
          onClick={() => removeItem?.(rec)}
        />
      )}
    </div>
  );
};

export default SelectedItem;
